// @ vendors
import React from "react";
import PropTypes from "prop-types";

// @ helpers
const { FormattedText } = require('core/i18n').i18n;

// @ commons
const { OKMessage } = require('commonsComponents/OKMessage');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @utilities
const { checkIfBudgetIsConfirmed } = require('utilities/mortgageHelper');

class DisclaimerMessageInsurancesRelated extends React.Component {

    buildPostalCodeDiscrepancyMessage() {
        const { postalCodeHasDiscrepancy } = this.props;
        const disclaimerMessagePrefix = __CONTACT_CENTER__ ? 'mortgageRequestPanelCC' : 'mortgageRequestPanel';

        return postalCodeHasDiscrepancy ? (
            <FormattedText
                className={'mortgage-request-manager-panel-steps__discrepancy-message'}
                value={`${disclaimerMessagePrefix}-${disclaimerMessagePrefix}_postalCodeDiscrepancyMessage`}
            />
        ) : null;
    }

    buildDisclaimerMessage() {
        const { isPostAppraisal, insuranceState } = this.props;

        const disclaimerMessagePrefix = __CONTACT_CENTER__ ? 'mortgageRequestPanelCC' : 'mortgageRequestPanel';
        let disclaimerMessage = 'mortgageRequestPanel-disclaimerMessageInsurancesRelated';
        const AppraisalWithoutPrevSimulation = isPostAppraisal && !insuranceState.get('data');

        if (AppraisalWithoutPrevSimulation) {
            disclaimerMessage = `${disclaimerMessagePrefix}-${disclaimerMessagePrefix}_insuranceRelatedAppraisalWithoutPrevSimulation`;
        } else if (isPostAppraisal) {
            disclaimerMessage = __CONTACT_CENTER__ ?
                `${disclaimerMessagePrefix}-${disclaimerMessagePrefix}_disclaimerMessageInsurancesRelated` :
                `${disclaimerMessagePrefix}-disclaimerMessageInsurancesRelated`;
            const insurancePostalCode = insuranceState.getIn(['data', 'home', 'postalCode']);
            const insuranceContinent = insuranceState.getIn(['data', 'continent'], 0);

            const property = insuranceState.getIn(['appraisal', 'property']);
            const appraisalPostalCode = property.get('postalCode');
            const appraisalImport = property.get('appraisalImport');
            const groundPrice = property.get('groundPrice');
            const continentMinimumValue = appraisalImport - groundPrice;

            const continentValueUnderMinimum = insuranceContinent !== continentMinimumValue;
            const postalCodeChanged = insurancePostalCode !== appraisalPostalCode;

            const changesHappened = continentValueUnderMinimum || postalCodeChanged;
            disclaimerMessage += changesHappened ? 'AfterAppraisalWithChanges' : 'AfterAppraisal';
        }

        return disclaimerMessage;
    }

    buildDisclaimer() {
        const { hasInsurance, insuranceState, isPostAppraisal } = this.props;
        const insuranceData = insuranceState.get('data');
        const budgetConfirmed = checkIfBudgetIsConfirmed(insuranceData);
        const hasInsuranceValidation = hasInsurance || insuranceData;
        const AppraisalWithoutPrevSimulation = !insuranceData && isPostAppraisal && hasInsuranceValidation;
        const showDisclaimer = !budgetConfirmed && hasInsuranceValidation && insuranceData !== null;
        if (showDisclaimer || AppraisalWithoutPrevSimulation) {
            const disclaimerMessage = this.buildDisclaimerMessage();
            return __CONTACT_CENTER__ && (AppraisalWithoutPrevSimulation || isPostAppraisal) ?
                (
                    <BlockInfo extraClass="home-insurance-step-product__cc-info">
                        <FormattedText value={disclaimerMessage} />
                    </BlockInfo>
                ) :
                (
                    <OKMessage type="informative">
                        {this.buildPostalCodeDiscrepancyMessage()}
                        <FormattedText value={disclaimerMessage} />
                    </OKMessage>
                );
        }
    }

    getMessageContainer(disclaimerMessage) {
        return (
            <OKMessage type="informative">
                <FormattedText value={disclaimerMessage} />
            </OKMessage>
        );
    }

    buildDisclaimerInsuranceRestricted(isBonusAvaiable) {
        const disclaimerMessage = isBonusAvaiable ?
            'mortgageRequestPanel-mortgageRequestPanel_disclaimerMessageInsuranceRestricted' :
            'mortgageRequestPanel-disclaimerMessageInsurancesRestricted';
        return this.getMessageContainer(disclaimerMessage);
    }

    buildDisclaimerInsuranceIsCompletedPostAppraisal() {
        const disclaimerMessage = 'mortgageRequestPanel-mortgageRequestPanel_disclaimerMessageInsuranceNotRestricted';
        return this.getMessageContainer(disclaimerMessage);
    }

    buildDisclaimerMessageInsurancesRelated() {
        const {
            hasInsurance,
            isBonusAvaiable,
            mortgageInsuranceState,
            insuranceIsRestricted,
            isPostAppraisal,
            showSpecialAppliesMessage,
        } = this.props;
        const isPriceClosed = mortgageInsuranceState.getIn(['insurancesRelatedStatusData', 'closedPrice']);
        const insuranceIsCompleted = isPostAppraisal ? this.buildDisclaimerInsuranceIsCompletedPostAppraisal() : null;
        const disclaimer = !isPriceClosed ? this.buildDisclaimer() : insuranceIsCompleted;
        const disclaimerMessage = insuranceIsRestricted && !hasInsurance
            ? this.buildDisclaimerInsuranceRestricted(isBonusAvaiable)
            : disclaimer

        return !showSpecialAppliesMessage && disclaimerMessage ? disclaimerMessage : <React.Fragment></React.Fragment>;
    }

    render() {
        const { accountHolder, isBonusAvaiable, insuranceIsRestricted, hasInsurance, insuranceState, isFetching } = this.props;
        const insuranceData = insuranceState.get('data');
        const secondAccountHolderMessage = "mortgageRequestPanel-secondaryAccountHolderMessage";
        const hasNotInsuranceMessage = "mortgageRequestPanel-mortgageRequestPanel_disclaimerMessageHasNotInsurance";
        const checkNotInsurance = isBonusAvaiable && !hasInsurance && !insuranceIsRestricted ? hasNotInsuranceMessage : null;
        const keyMessage = accountHolder !== 1 && insuranceData === null ? secondAccountHolderMessage : checkNotInsurance;

        const disclaimerMessageInsurancesRelated = keyMessage ?
            (
                <OKMessage type="informative">
                    <FormattedText value={keyMessage} />
                </OKMessage>
            )
            : this.buildDisclaimerMessageInsurancesRelated();

        return isFetching ?  <LoadingSection />: disclaimerMessageInsurancesRelated || <React.Fragment></React.Fragment>
        
    }
}

DisclaimerMessageInsurancesRelated.propTypes = {
  hasInsurance: PropTypes.bool,
  isBonusAvaiable: PropTypes.bool,
  accountHolder: PropTypes.string,
  mortgageInsuranceState: PropTypes.object.isRequired,
  insuranceIsRestricted: PropTypes.bool.isRequired,
  showSpecialAppliesMessage: PropTypes.bool.isRequired,
  insuranceState: PropTypes.object.isRequired,
  isPostAppraisal: PropTypes.bool.isRequired,
  postalCodeHasDiscrepancy: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
}

module.exports = DisclaimerMessageInsurancesRelated;